import { CallApiOptions } from './api';

export const brandListCallOptions = (params: object = {}): CallApiOptions => ({
  method: 'GET',
  endpoint: 'brands',
  params: {
    limit: 10000,
    include: 'images',
    ...params,
  },
});

export const fetchBrandCallOptions = (
  brandId: number,
  include: string[]
): CallApiOptions => ({
  method: 'GET',
  endpoint: `brands/${brandId}`,
});



// WEBPACK FOOTER //
// ./src/services/brandlist.services.ts